import PropTypes from "prop-types";
import React from "react";

import { Fade } from "react-awesome-reveal";

import "./_style.scss";

const Timeline = ({ children }) => (
  <div className="timeline">
    <div className="timeline__label --intro">Scroll down to view</div>
    <div className="timeline__start" />
    <div className="timeline__list">
      {React.Children.map(children, (child) => (
        <Fade direction="up" delay={100} duration={400} triggerOnce>
          <div className="timeline__item">
            {child}
          </div>
        </Fade>
      ))}
    </div>
    <div className="timeline__end" />
    <div className="timeline__label --outro">To be continued...</div>
  </div>
);

Timeline.propTypes = {
  children: PropTypes.node,
};

export default Timeline;
